(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-custom-collection"] && !Shopify.designMode) return;
  try {
    
  // Función para asegurar que flexbox funcione correctamente después de que se carguen las imágenes
  function ensureFlexAlignment() {
    const tabContents = document.querySelectorAll('.t4s-tab-content2.t4s-active');
    
    tabContents.forEach(tabContent => {
      const wrapper = tabContent.querySelector('.tab-content-wrapper.has-sidebar-image');
      if (wrapper) {
        // Forzar un reflow para que flexbox se recalcule
        wrapper.style.display = 'none';
        wrapper.offsetHeight; // trigger reflow
        wrapper.style.display = 'flex';
      }
    });
  }
  
  // Ejecutar cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', function() {
    // Ejecutar después de que las imágenes se carguen
    setTimeout(() => {
      ensureFlexAlignment();
    }, 500);
    
    // También ejecutar cuando cambien de tab
    const tabLinks = document.querySelectorAll('[data-t4s-tab-item]');
    tabLinks.forEach(link => {
      link.addEventListener('click', function() {
        setTimeout(() => {
          ensureFlexAlignment();
        }, 300);
      });
    });
    
    // Observar cuando se inicialice el carrusel Flickity
    const flickitySliders = document.querySelectorAll('.flickityt4s');
    flickitySliders.forEach(slider => {
      slider.addEventListener('ready.flickity', function() {
        setTimeout(() => {
          ensureFlexAlignment();
        }, 100);
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
